var _style, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErcLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 81.8 81.9",
    style: {
      enableBackground: "new 0 0 81.8 81.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t\n\t\t.st0{clip-path:url(#SVGID_00000032619027959224746820000004516016110677821571_);fill:url(#SVGID_00000131350140268131826120000014911990337414277301_);}\n\t.st1{fill:#E65C25;}\n\t.st2{fill:#FFFDEE;}\n")), /*#__PURE__*/React.createElement("g", {
    id: "ERC_Logo_00000080915025938964479880000013840855325887048090_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M62.7,73.9c-0.3,0.2-0.4,0.7-0.2,1c0.2,0.3,0.7,0.4,1,0.2c0.3-0.2,0.4-0.7,0.2-1 c-0.1-0.2-0.3-0.3-0.6-0.3C62.9,73.8,62.8,73.8,62.7,73.9 M68.8,68.9c-0.3,0.2-0.3,0.8,0,1c0.2,0.3,0.8,0.3,1,0 c0.3-0.2,0.3-0.8,0-1c-0.1-0.1-0.3-0.2-0.6-0.2C69.1,68.6,68.9,68.8,68.8,68.9 M63.3,68.5c-0.4,0.2-0.6,0.8-0.2,1.2 c0.2,0.4,0.8,0.6,1.2,0.2c0.4-0.2,0.6-0.8,0.2-1.2c-0.2-0.2-0.4-0.4-0.8-0.4C63.7,68.3,63.4,68.4,63.3,68.5 M57.9,67.2 c-0.7,0.4-0.8,1.2-0.4,1.9c0.4,0.7,1.2,0.8,1.9,0.4c0.7-0.4,0.9-1.2,0.4-1.9c-0.2-0.4-0.7-0.7-1.2-0.7 C58.3,67,58.1,67,57.9,67.2 M73.1,63.8c-0.2,0.3-0.1,0.8,0.1,1c0.3,0.2,0.8,0.1,1-0.1c0.2-0.3,0.1-0.8-0.1-1 c-0.1-0.1-0.2-0.1-0.4-0.1S73.2,63.7,73.1,63.8 M68.3,63.5c-0.3,0.3-0.3,0.9,0,1.2c0.3,0.3,0.9,0.3,1.2,0c0.3-0.3,0.3-0.9,0-1.2 c-0.2-0.2-0.4-0.2-0.7-0.2C68.8,63.2,68.5,63.3,68.3,63.5 M62.8,63.2c-0.6,0.6-0.6,1.4,0,2c0.6,0.6,1.4,0.6,2,0 c0.6-0.6,0.6-1.4,0-2c-0.2-0.3-0.7-0.4-1-0.4C63.4,62.9,63.1,63,62.8,63.2 M57.8,61.7c-0.7,0.4-0.9,1.3-0.4,2 c0.4,0.7,1.3,0.9,2,0.4c0.7-0.4,0.9-1.3,0.4-2c-0.3-0.4-0.8-0.7-1.2-0.7C58.3,61.3,58,61.4,57.8,61.7 M53.1,59.5 c-0.8,0.6-1,1.6-0.6,2.3c0.6,0.8,1.6,1,2.3,0.6c0.8-0.6,1-1.6,0.6-2.3c-0.3-0.6-0.9-0.8-1.4-0.8C53.8,59.3,53.4,59.4,53.1,59.5  M66.9,58.2c-0.4,0.7-0.2,1.4,0.3,1.9c0.7,0.4,1.4,0.2,1.9-0.3c0.4-0.7,0.2-1.4-0.3-1.9c-0.2-0.1-0.6-0.2-0.8-0.2 C67.6,57.7,67.2,57.9,66.9,58.2 M61.4,58c-0.6,0.6-0.6,1.4,0,2.1c0.6,0.6,1.4,0.6,2.1,0c0.6-0.6,0.6-1.4,0-2.1 c-0.3-0.3-0.7-0.4-1-0.4C62.1,57.5,61.7,57.7,61.4,58 M72.2,57.8c-0.2,0.4-0.2,1,0.2,1.2c0.4,0.2,1,0.2,1.2-0.2 c0.3-0.4,0.2-1-0.2-1.2c-0.1-0.1-0.3-0.1-0.4-0.1C72.6,57.4,72.3,57.5,72.2,57.8 M77.1,56.8c-0.1,0.3,0,0.8,0.3,0.9 c0.3,0.1,0.8,0,0.9-0.3c0.1-0.3,0-0.8-0.3-0.9c-0.1,0-0.2-0.1-0.3-0.1C77.4,56.3,77.2,56.5,77.1,56.8 M56.5,56.8 c-0.7,0.7-0.7,1.8,0,2.4c0.7,0.7,1.8,0.7,2.4,0c0.7-0.7,0.7-1.8,0-2.4c-0.3-0.3-0.8-0.6-1.2-0.6C57.3,56.3,56.9,56.4,56.5,56.8  M51.5,54.2c-0.9,0.7-1,1.9-0.3,2.8c0.7,0.9,1.9,1,2.8,0.3s1-1.9,0.3-2.8c-0.4-0.4-1-0.8-1.6-0.8C52.3,53.9,51.9,54,51.5,54.2  M59.3,53.5c-0.6,0.8-0.3,1.9,0.4,2.3c0.8,0.6,1.9,0.3,2.3-0.4c0.6-0.8,0.3-1.9-0.4-2.3c-0.3-0.2-0.7-0.3-1-0.3 C60.1,52.8,59.7,53.1,59.3,53.5 M64.4,53.3c-0.4,0.7-0.3,1.6,0.3,2c0.7,0.4,1.6,0.2,2-0.3c0.4-0.7,0.2-1.6-0.3-2 c-0.2-0.2-0.6-0.2-0.8-0.2C65.2,52.8,64.8,53,64.4,53.3 M69.8,53.1c-0.3,0.7,0,1.6,0.8,1.8c0.7,0.3,1.6,0,1.8-0.8 c0.3-0.7,0-1.6-0.8-1.8c-0.2-0.1-0.3-0.1-0.6-0.1C70.4,52.2,70,52.5,69.8,53.1 M46.2,50.5c-1.2,0.4-1.9,1.7-1.4,2.9 c0.3,1.2,1.7,1.9,2.9,1.4c1.2-0.3,1.9-1.7,1.4-2.9c-0.3-1-1.2-1.6-2.2-1.6C46.7,50.4,46.4,50.4,46.2,50.5 M75,51 c-0.2,0.4,0,1,0.4,1.1c0.4,0.2,1,0,1.1-0.4c0.2-0.4,0-1-0.4-1.1c-0.1,0-0.2-0.1-0.3-0.1C75.5,50.4,75.2,50.7,75,51 M55.2,50.2 c-0.6,0.9-0.3,2.1,0.6,2.8c0.9,0.6,2.1,0.3,2.7-0.6s0.3-2.1-0.6-2.7c-0.3-0.2-0.7-0.3-1.1-0.3C56.3,49.3,55.7,49.7,55.2,50.2  M61.5,49.4c-0.3,0.9,0,1.9,0.9,2.2s1.9,0,2.2-0.9s-0.1-1.9-0.9-2.2c-0.2-0.1-0.4-0.1-0.7-0.1C62.4,48.4,61.8,48.8,61.5,49.4  M66.4,48.8c-0.3,0.8,0,1.6,0.8,1.9c0.8,0.3,1.6,0,1.9-0.8c0.3-0.8,0-1.6-0.8-1.9c-0.2-0.1-0.3-0.1-0.6-0.1 C67.2,47.9,66.6,48.2,66.4,48.8 M79.6,48.3c-0.1,0.3,0.2,0.8,0.6,0.9c0.3,0.1,0.8-0.2,0.9-0.6c0.1-0.3-0.2-0.8-0.6-0.8h-0.1 C80.1,47.8,79.8,48,79.6,48.3 M49.8,47.5c-0.9,0.9-1,2.3-0.1,3.2c0.9,0.9,2.3,1,3.2,0.1c0.9-0.9,1-2.3,0.2-3.2 c-0.4-0.6-1.1-0.8-1.7-0.8C50.8,47,50.2,47.1,49.8,47.5 M71.5,47.2c-0.1,0.8,0.3,1.4,1.1,1.7c0.8,0.1,1.4-0.3,1.7-1.1 c0.1-0.8-0.3-1.4-1.1-1.7c-0.1,0-0.2,0-0.3,0C72.3,46.1,71.6,46.5,71.5,47.2 M57.2,46.1c-0.3,1,0.2,2.1,1.2,2.4 c1,0.3,2.1-0.2,2.4-1.2c0.3-1-0.2-2.1-1.2-2.4c-0.2-0.1-0.4-0.1-0.6-0.1C58.2,44.8,57.4,45.3,57.2,46.1 M62.8,45.4 c-0.2,0.9,0.4,1.9,1.3,2c0.9,0.2,1.8-0.4,2-1.3c0.2-0.9-0.4-1.8-1.3-2c-0.1,0-0.2,0-0.3,0C63.7,44.1,62.9,44.7,62.8,45.4  M76.3,43.9c-0.1,0.4,0.2,1,0.7,1c0.4,0.1,0.9-0.2,1-0.7c0.1-0.4-0.2-1-0.7-1c-0.1,0-0.1,0-0.2,0C76.8,43.2,76.4,43.5,76.3,43.9  M67.4,43.9c-0.2,0.8,0.3,1.6,1.1,1.8c0.8,0.2,1.6-0.3,1.8-1.1c0.2-0.8-0.3-1.6-1.1-1.8c-0.1,0-0.2,0-0.3,0 C68.2,42.8,67.5,43.2,67.4,43.9 M51.7,43.7c-0.6,1.1,0,2.6,1.1,3c1.1,0.6,2.6,0,3-1.1c0.6-1.1,0-2.6-1.1-3 c-0.3-0.1-0.7-0.2-1-0.2C52.9,42.3,52.1,42.8,51.7,43.7 M81.1,39.7c-0.4,0-0.7,0.3-0.7,0.7c0,0.4,0.3,0.7,0.7,0.7 c0.4,0,0.7-0.3,0.7-0.7C81.8,39.9,81.5,39.7,81.1,39.7L81.1,39.7 M65,39.4c-0.9,0-1.7,0.8-1.7,1.7c0,1,0.8,1.7,1.7,1.8 c1,0,1.7-0.8,1.8-1.7C66.6,40.2,65.9,39.4,65,39.4L65,39.4 M58,41.2c0,1.1,0.9,2,1.9,2c1.1,0,2-0.9,2-1.9c0-1.1-0.9-2-1.9-2l0,0 C58.9,39.2,58.1,40.1,58,41.2 M73.5,39.1c-0.8,0-1.3,0.7-1.3,1.4c0,0.8,0.7,1.3,1.4,1.3c0.8,0,1.3-0.7,1.3-1.4 C75,39.8,74.3,39.1,73.5,39.1L73.5,39.1 M68.9,36.7c-0.8,0-1.4,0.7-1.4,1.4s0.7,1.4,1.4,1.4c0.8,0,1.4-0.7,1.4-1.4 C70.3,37.3,69.6,36.7,68.9,36.7L68.9,36.7 M54.1,36.7c-1.2,0-2.3,1-2.3,2.2c0,1.2,1,2.3,2.2,2.3c1.2,0,2.3-1,2.3-2.2 C56.4,37.7,55.4,36.7,54.1,36.7C54.2,36.7,54.2,36.7,54.1,36.7 M77.1,35.5c-0.4,0-0.9,0.4-0.9,0.9c0,0.4,0.4,0.9,0.9,0.9 c0.4,0,0.9-0.4,0.9-0.9C78,36,77.5,35.5,77.1,35.5L77.1,35.5 M64,34.3c-0.9,0.2-1.4,1.1-1.3,2c0.2,0.9,1.1,1.4,2.1,1.3 c0.9-0.2,1.4-1.1,1.2-2.1c-0.2-0.8-0.9-1.3-1.7-1.3C64.2,34.3,64.1,34.3,64,34.3 M58.3,33.2c-1,0.3-1.6,1.4-1.2,2.4 s1.4,1.6,2.4,1.2c1-0.3,1.6-1.4,1.2-2.4c-0.2-0.8-1-1.3-1.9-1.3C58.8,33.1,58.5,33.1,58.3,33.2 M72.5,32.7 c-0.8,0.1-1.2,0.9-1.1,1.7c0.1,0.8,0.9,1.2,1.7,1.1c0.8-0.1,1.2-0.9,1.1-1.7c-0.1-0.7-0.7-1.1-1.3-1.1 C72.8,32.7,72.6,32.7,72.5,32.7 M80.1,31.8c-0.3,0.1-0.7,0.4-0.6,0.9c0.1,0.3,0.4,0.7,0.9,0.6c0.3-0.1,0.7-0.4,0.6-0.9 c-0.1-0.3-0.3-0.6-0.7-0.6C80.2,31.8,80.1,31.8,80.1,31.8 M51.1,31.4c-1.1,0.6-1.7,1.9-1.1,3c0.6,1.1,1.9,1.7,3,1.1 c1.1-0.6,1.7-1.9,1.1-3c-0.3-0.9-1.2-1.3-2.1-1.3C51.8,31.2,51.4,31.2,51.1,31.4 M67.4,31c-0.8,0.1-1.3,0.9-1.1,1.7 c0.1,0.8,0.9,1.3,1.7,1.1c0.8-0.1,1.3-0.9,1.1-1.7c-0.1-0.7-0.8-1.2-1.4-1.2C67.6,31,67.5,31,67.4,31 M62.3,29.9 c-0.9,0.3-1.2,1.3-0.9,2.2c0.3,0.9,1.3,1.2,2.2,0.9c0.9-0.3,1.2-1.3,0.9-2.2c-0.3-0.7-0.9-1-1.6-1 C62.8,29.7,62.5,29.8,62.3,29.9 M75.5,29.2c-0.4,0.1-0.8,0.6-0.7,1c0.1,0.4,0.6,0.8,1,0.7c0.4-0.1,0.8-0.6,0.7-1 c-0.1-0.4-0.4-0.7-0.9-0.7C75.6,29.2,75.6,29.2,75.5,29.2 M54.7,27.7c-0.9,0.7-1,1.9-0.3,2.8c0.7,0.9,1.9,1,2.8,0.3 c0.9-0.7,1-1.9,0.3-2.8c-0.3-0.6-1-0.8-1.6-0.8C55.4,27.3,55,27.4,54.7,27.7 M46.2,28c-0.8,1-0.7,2.4,0.2,3.2 c1,0.8,2.4,0.7,3.2-0.2c0.8-1,0.7-2.4-0.2-3.2c-0.4-0.3-1-0.6-1.4-0.6C47.3,27.1,46.7,27.4,46.2,28 M70.5,26.9 c-0.7,0.3-1,1.1-0.8,1.8c0.3,0.7,1.1,1,1.8,0.8c0.7-0.3,1-1.1,0.8-1.8c-0.2-0.6-0.8-0.9-1.3-0.9C70.9,26.8,70.6,26.9,70.5,26.9  M65.1,26.2c-0.8,0.3-1.1,1.1-0.8,1.9s1.1,1.1,1.9,0.8c0.8-0.3,1.1-1.1,0.8-1.9c-0.2-0.6-0.8-0.9-1.3-0.9 C65.4,26.1,65.3,26.1,65.1,26.2 M60,26.1c-0.8,0.6-1,1.6-0.6,2.3c0.6,0.8,1.6,1,2.3,0.6c0.8-0.6,1-1.6,0.6-2.3 c-0.3-0.6-0.9-0.8-1.4-0.8C60.7,25.9,60.3,26,60,26.1 M77.8,24.8c-0.3,0.1-0.6,0.6-0.3,0.9c0.1,0.3,0.6,0.6,0.9,0.3 c0.3-0.1,0.6-0.6,0.3-0.9c-0.1-0.2-0.3-0.4-0.7-0.4C77.9,24.7,77.9,24.7,77.8,24.8 M72.9,23.2c-0.4,0.2-0.7,0.7-0.4,1.1 s0.7,0.7,1.1,0.4c0.4-0.2,0.7-0.7,0.4-1.1c-0.1-0.3-0.4-0.6-0.8-0.6C73.1,23.2,73,23.2,72.9,23.2 M49.7,24 c-0.6,0.9-0.3,2.1,0.6,2.8c0.9,0.6,2.1,0.3,2.8-0.6c0.6-0.9,0.3-2.1-0.6-2.8c-0.3-0.2-0.7-0.3-1.1-0.3 C50.7,23.1,50.1,23.4,49.7,24 M56.7,22.7c-0.7,0.7-0.7,1.8,0,2.4c0.7,0.7,1.8,0.7,2.4,0c0.7-0.7,0.7-1.8,0-2.4 c-0.3-0.3-0.8-0.4-1.2-0.4S57,22.3,56.7,22.7 M67.6,22c-0.7,0.4-0.8,1.2-0.4,1.9c0.4,0.7,1.2,0.8,1.9,0.4 c0.7-0.4,0.8-1.2,0.4-1.9c-0.2-0.4-0.7-0.7-1.2-0.7C68.1,21.8,67.9,21.8,67.6,22 M61.8,21.7c-0.7,0.4-0.9,1.3-0.4,2 s1.3,0.9,2,0.4c0.7-0.4,0.9-1.3,0.4-2c-0.3-0.4-0.8-0.7-1.2-0.7C62.3,21.4,62,21.5,61.8,21.7 M53,20c-0.6,0.8-0.3,1.9,0.4,2.3 c0.8,0.6,1.9,0.3,2.3-0.4c0.6-0.8,0.3-1.9-0.4-2.3c-0.3-0.2-0.7-0.3-1-0.3C53.9,19.2,53.3,19.6,53,20 M74,18 c-0.3,0.2-0.4,0.7-0.2,1c0.2,0.3,0.7,0.4,1,0.2c0.3-0.2,0.4-0.7,0.2-1c-0.1-0.2-0.3-0.3-0.6-0.3S74.1,17.9,74,18 M57.7,18 c-0.6,0.6-0.6,1.4,0,2.1c0.6,0.6,1.4,0.6,2.1,0c0.6-0.6,0.6-1.4,0-2.1c-0.3-0.3-0.7-0.4-1-0.4C58.3,17.6,57.9,17.7,57.7,18  M68.6,17c-0.4,0.2-0.6,0.8-0.2,1.2c0.2,0.4,0.8,0.6,1.2,0.2c0.4-0.2,0.6-0.8,0.2-1.2c-0.2-0.2-0.4-0.4-0.8-0.4 C69,16.9,68.8,17,68.6,17 M63.1,16.8c-0.6,0.6-0.6,1.4,0,2c0.6,0.6,1.4,0.6,2,0c0.6-0.6,0.6-1.4,0-2c-0.2-0.2-0.7-0.4-1-0.4 C63.7,16.4,63.3,16.6,63.1,16.8 M57.9,12.9c-0.4,0.7-0.2,1.4,0.3,1.9c0.7,0.4,1.4,0.2,1.9-0.3c0.4-0.7,0.2-1.4-0.3-1.9 c-0.2-0.1-0.6-0.2-0.8-0.2C58.5,12.3,58.1,12.4,57.9,12.9 M69.1,12.2c-0.3,0.2-0.3,0.8,0,1c0.2,0.3,0.8,0.3,1,0 c0.3-0.2,0.3-0.8,0-1C70,12.1,69.8,12,69.5,12C69.4,12,69.2,12.1,69.1,12.2 M63.7,12.2c-0.3,0.3-0.3,0.9,0,1.2 c0.3,0.3,0.9,0.3,1.2,0s0.3-0.9,0-1.2C64.6,12,64.4,12,64.2,12C64.1,12,63.9,12.1,63.7,12.2 M63.1,7.3c-0.2,0.3-0.1,0.8,0.2,1 c0.3,0.2,0.8,0.1,1-0.2c0.2-0.3,0.1-0.8-0.2-1C64,7,63.9,7,63.7,7C63.5,7.1,63.3,7.2,63.1,7.3"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000160170640186065081390000012383086050679020947_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000007427814330742070190000004117248412065153152_",
    gradientUnits: "userSpaceOnUse",
    x1: -557.0651,
    y1: 42.3441,
    x2: -556.6833,
    y2: 42.3441,
    gradientTransform: "matrix(97.1756 0 0 97.1756 54177.832 -4073.6057)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E65C25"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 44.3,
    y: 7.1,
    style: {
      clipPath: "url(#SVGID_00000160170640186065081390000012383086050679020947_)",
      fill: "url(#SVGID_00000007427814330742070190000004117248412065153152_)"
    },
    width: 37.5,
    height: 68.2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M44.8,28.1c-0.3,1.2-1.6,1.9-2.8,1.6c-1.2-0.3-1.9-1.6-1.6-2.8c0.3-1.2,1.6-1.9,2.8-1.6 C44.4,25.7,45.1,26.9,44.8,28.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M39.4,53.9c0.1-1.2,1.2-2.2,2.4-2.1c1.2,0.1,2.2,1.2,2.1,2.4c-0.1,1.2-1.2,2.2-2.4,2.1 C40.3,56.3,39.3,55.2,39.4,53.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M34.5,52.3c0.6-1.1,2-1.6,3.1-1c1.1,0.6,1.6,2,1,3.1c-0.6,1.1-2,1.6-3.1,1C34.3,54.9,33.9,53.4,34.5,52.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M30.4,48.8c1-0.8,2.4-0.7,3.2,0.3c0.8,1,0.7,2.4-0.3,3.2c-1,0.8-2.4,0.7-3.2-0.3C29.3,51,29.4,49.5,30.4,48.8 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M28.1,43.9c1.2-0.3,2.4,0.4,2.8,1.7s-0.4,2.4-1.7,2.8c-1.2,0.3-2.4-0.4-2.8-1.7 C26.2,45.5,26.9,44.2,28.1,43.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M27.9,38.8c1.2,0.1,2.1,1.3,2,2.6c-0.1,1.2-1.3,2.1-2.6,2c-1.2-0.1-2.1-1.3-2-2.6 C25.4,39.4,26.7,38.5,27.9,38.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M29.8,33.8c1.1,0.7,1.4,2.1,0.8,3.1c-0.7,1.1-2.1,1.4-3.1,0.8c-1.1-0.7-1.4-2.1-0.8-3.1 C27.3,33.4,28.7,33.1,29.8,33.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M33.4,29.9c0.8,1,0.6,2.4-0.6,3.2c-1,0.8-2.4,0.6-3.2-0.6c-0.8-1-0.6-2.4,0.6-3.2 C31.3,28.7,32.8,28.9,33.4,29.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M39,27.8c0.2,1.2-0.7,2.4-1.9,2.7c-1.2,0.2-2.4-0.7-2.7-1.9c-0.2-1.2,0.7-2.4,1.9-2.7 C37.7,25.7,38.8,26.4,39,27.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M42.9,60c0,1.1-0.9,2-2,2c-1.1,0-2-0.9-2-2c0-1.1,0.9-2,2-2C42.1,58,42.9,58.9,42.9,60"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M48.9,58.3c0.3,1-0.2,2.1-1.2,2.4c-1,0.3-2.1-0.2-2.4-1.2s0.2-2.1,1.2-2.4C47.4,56.8,48.5,57.3,48.9,58.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M38.9,21.9c0-1.1,0.9-1.9,2-1.9c1.1,0,1.9,0.9,1.9,2c0,1.1-1,1.9-2,1.9C39.7,23.9,38.9,23,38.9,21.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M44.7,22c0.3-1,1.4-1.6,2.4-1.2c1,0.3,1.6,1.4,1.2,2.4c-0.3,1-1.4,1.6-2.4,1.2C44.9,24.2,44.3,23.1,44.7,22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M33.1,23.4c-0.3-1,0.2-2.1,1.3-2.4c1-0.3,2.1,0.2,2.4,1.3c0.3,1-0.2,2.1-1.3,2.4 C34.5,25.1,33.4,24.5,33.1,23.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M27.8,27.1c-0.7-0.9-0.4-2.1,0.3-2.8c0.9-0.7,2.1-0.4,2.8,0.3c0.7,0.9,0.4,2.1-0.3,2.8 C29.7,28.1,28.4,28,27.8,27.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M22.2,37.1c-1-0.3-1.6-1.4-1.2-2.6c0.3-1,1.4-1.6,2.6-1.2c1,0.3,1.6,1.4,1.2,2.6C24.3,37,23.2,37.4,22.2,37.1 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M24.1,31.5c-0.9-0.7-1.1-1.9-0.6-2.8c0.7-0.9,1.9-1.1,2.8-0.6c0.9,0.7,1.1,1.9,0.6,2.8 C26.2,32,25,32.2,24.1,31.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M21.9,43c-1.1,0-1.9-1-1.9-2c0-1.1,1-1.9,2-1.9c1.1,0,1.9,1,1.9,2C23.9,42.2,23,43.1,21.9,43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M23.4,48.9c-1,0.3-2.1-0.3-2.4-1.3c-0.3-1,0.3-2.1,1.3-2.4c1-0.3,2.1,0.3,2.4,1.3 C25.1,47.4,24.4,48.5,23.4,48.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M26.9,53.9c-0.9,0.7-2.1,0.4-2.8-0.4s-0.4-2.1,0.4-2.8s2.1-0.4,2.8,0.4C27.9,52.1,27.8,53.3,26.9,53.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M36.3,59.7c-0.3,1-1.6,1.6-2.6,1.2c-1-0.3-1.6-1.6-1.2-2.6c0.3-1,1.6-1.6,2.6-1.2 C36.2,57.4,36.8,58.7,36.3,59.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M31.4,57.7c-0.7,0.9-1.9,1.1-2.8,0.4c-0.9-0.7-1.1-1.9-0.4-2.8c0.7-0.9,1.9-1.1,2.8-0.4 C31.9,55.5,32,56.8,31.4,57.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M42.7,16.9c0,1-0.8,1.7-1.7,1.7c-0.9,0-1.7-0.8-1.7-1.7c0-1,0.8-1.7,1.7-1.7C41.9,15.1,42.7,15.9,42.7,16.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M47.3,17.7c-0.2,0.9-1.1,1.6-2,1.3s-1.6-1.1-1.3-2c0.2-0.9,1.1-1.6,2-1.3C47,15.8,47.5,16.8,47.3,17.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M51.5,19.2c-0.3,0.9-1.3,1.3-2.2,1s-1.3-1.3-1-2.2s1.3-1.3,2.2-1S51.9,18.3,51.5,19.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M16.9,39.3c1,0,1.7,0.8,1.8,1.7c0,1-0.8,1.7-1.7,1.8c-1,0-1.7-0.8-1.8-1.7C15.1,40.1,15.9,39.3,16.9,39.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M17.7,34.5c0.9,0.2,1.6,1.1,1.3,2c-0.2,0.9-1.1,1.6-2,1.3s-1.6-1.1-1.3-2C15.8,35,16.7,34.4,17.7,34.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M19.2,30.4c0.9,0.3,1.3,1.3,1,2.2c-0.3,0.9-1.3,1.3-2.2,1c-0.9-0.3-1.3-1.3-1-2.2 C17.3,30.4,18.3,30,19.2,30.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M21.9,26.1c0.8,0.6,1,1.6,0.4,2.3c-0.6,0.8-1.6,1-2.3,0.4s-1-1.6-0.4-2.3C20,25.8,21.1,25.5,21.9,26.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M25,22.8c0.7,0.7,0.7,1.8,0,2.4c-0.7,0.7-1.8,0.7-2.4,0s-0.7-1.8,0-2.4C23.2,22.1,24.3,22.1,25,22.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M28.9,20c0.6,0.8,0.3,1.9-0.4,2.3c-0.8,0.6-1.9,0.3-2.3-0.4c-0.6-0.8-0.3-1.9,0.4-2.3 C27.3,19,28.3,19.2,28.9,20"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M32.9,18.1c0.3,0.9,0,1.9-0.9,2.2c-0.9,0.3-1.9,0-2.2-0.9c-0.3-0.9,0-1.9,0.9-2.2 C31.4,16.9,32.4,17.3,32.9,18.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M37.5,17.1c0.2,0.9-0.3,1.9-1.2,2.1c-0.9,0.2-1.9-0.3-2.1-1.2s0.3-1.9,1.2-2.1C36.4,15.6,37.3,16.2,37.5,17.1 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M39.3,64.9c0-1,0.8-1.7,1.7-1.8c1,0,1.7,0.8,1.8,1.7c0,1-0.8,1.7-1.7,1.8C40.1,66.6,39.3,65.9,39.3,64.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M34.7,64.1c0.2-0.9,1.1-1.6,2-1.3c0.9,0.2,1.6,1.1,1.3,2c-0.2,0.9-1.1,1.6-2,1.3C35.1,66,34.4,65.1,34.7,64.1 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M30.4,62.5c0.3-0.9,1.3-1.3,2.2-1c0.9,0.3,1.3,1.3,1,2.2c-0.3,0.9-1.3,1.3-2.2,1 C30.5,64.4,30.1,63.4,30.4,62.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M26.1,59.9c0.6-0.8,1.6-1,2.3-0.4c0.8,0.6,1,1.6,0.4,2.3c-0.6,0.8-1.6,1-2.3,0.4 C25.9,61.8,25.7,60.7,26.1,59.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M22.8,56.8c0.7-0.7,1.8-0.7,2.4,0c0.7,0.7,0.7,1.8,0,2.4c-0.7,0.7-1.8,0.7-2.4,0 C22.1,58.5,22.1,57.4,22.8,56.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M20,52.9c0.8-0.6,1.9-0.3,2.3,0.4c0.6,0.8,0.3,1.9-0.4,2.3c-0.8,0.6-1.9,0.3-2.3-0.4 C19,54.4,19.2,53.4,20,52.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M18.2,48.9c0.9-0.3,1.9,0,2.2,0.9c0.3,0.9,0,1.9-0.9,2.2s-1.9,0-2.2-0.9C16.9,50.3,17.3,49.3,18.2,48.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M17.1,44.2c0.9-0.2,1.9,0.3,2.1,1.2c0.2,0.9-0.3,1.9-1.2,2.1s-1.9-0.3-2.1-1.2C15.7,45.4,16.2,44.4,17.1,44.2 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M48.7,63.7c-0.3-0.9,0-1.9,0.9-2.2c0.9-0.3,1.9,0,2.2,0.9c0.3,0.9,0,1.9-0.9,2.2C50,65,49,64.5,48.7,63.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M43.9,64.6c-0.2-0.9,0.3-1.9,1.3-2c0.9-0.2,1.9,0.3,2,1.3c0.2,0.9-0.3,1.9-1.3,2 C45.1,66.2,44.1,65.6,43.9,64.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M39.2,12.8c0,0.8-0.7,1.4-1.4,1.4s-1.4-0.7-1.4-1.4c0-0.8,0.7-1.4,1.4-1.4C38.7,11.3,39.2,12,39.2,12.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M45.8,13.2c-0.2,0.8-1,1.2-1.8,1.1c-0.8-0.2-1.2-1-1.1-1.8c0.2-0.8,1-1.2,1.8-1.1 C45.4,11.7,46,12.4,45.8,13.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M50.9,14.7c-0.3,0.8-1.2,1.1-1.9,0.8c-0.8-0.3-1.1-1.2-0.8-1.9c0.3-0.8,1.2-1.1,1.9-0.8 C50.9,13,51.2,13.9,50.9,14.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M55.3,16.8c-0.4,0.7-1.3,0.9-2,0.3c-0.7-0.4-0.9-1.3-0.3-2c0.4-0.7,1.3-0.9,2-0.3 C55.7,15.2,55.8,16.1,55.3,16.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M52.8,66.3c-0.3-0.8,0-1.6,0.8-1.9c0.8-0.3,1.6,0.1,1.9,0.8c0.3,0.8,0,1.6-0.8,1.9 C54,67.4,53.1,67.1,52.8,66.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M47.7,68.1c-0.1-0.8,0.3-1.6,1.1-1.7c0.8-0.1,1.6,0.3,1.7,1.1c0.1,0.8-0.3,1.6-1.1,1.7 C48.7,69.4,47.9,68.9,47.7,68.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M42.4,69c0-0.8,0.7-1.4,1.4-1.4s1.4,0.7,1.4,1.4c0,0.8-0.7,1.4-1.4,1.4S42.4,69.8,42.4,69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M36.2,68.6c0.2-0.8,1-1.3,1.8-1.1c0.8,0.2,1.3,1,1.1,1.8c-0.2,0.8-1,1.3-1.8,1.1C36.5,70.2,36,69.4,36.2,68.6 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M31.7,67.4c0.3-0.8,1.1-1.1,1.9-0.8c0.8,0.3,1.1,1.1,0.8,1.9c-0.3,0.8-1.1,1.1-1.9,0.8 C31.7,69.1,31.3,68.2,31.7,67.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M25.7,64.5c0.4-0.7,1.3-0.8,2-0.3c0.7,0.4,0.8,1.3,0.3,2c-0.4,0.7-1.3,0.8-2,0.3 C25.3,66.1,25.1,65.2,25.7,64.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M21.8,61.7c0.6-0.6,1.4-0.6,2.1,0c0.6,0.6,0.6,1.6,0,2.1c-0.6,0.6-1.4,0.6-2.1,0 C21.2,63.1,21.2,62.2,21.8,61.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M18.1,57.5c0.7-0.4,1.6-0.2,2,0.4c0.4,0.7,0.2,1.6-0.4,2c-0.7,0.4-1.6,0.2-2-0.4C17.2,58.9,17.4,58,18.1,57.5 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M15.6,53.2c0.8-0.3,1.6,0,1.9,0.8c0.3,0.8,0,1.6-0.8,1.9c-0.8,0.3-1.6,0-1.9-0.8 C14.4,54.4,14.8,53.5,15.6,53.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M13.8,48.8c0.8-0.2,1.6,0.3,1.8,1.1c0.2,0.8-0.3,1.6-1.1,1.8c-0.8,0.2-1.6-0.3-1.8-1.1 C12.6,49.8,13,49,13.8,48.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M12.7,42.8c0.8,0,1.4,0.7,1.4,1.4s-0.7,1.4-1.4,1.4s-1.4-0.7-1.4-1.4C11.2,43.4,11.9,42.8,12.7,42.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M12.9,36.9c0.8,0.1,1.3,0.9,1.1,1.7c-0.1,0.8-0.9,1.3-1.7,1.1c-0.8-0.1-1.3-0.9-1.1-1.7 C11.3,37.2,12.1,36.8,12.9,36.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M14.3,31.4c0.8,0.3,1.1,1.2,0.8,1.9c-0.3,0.8-1.1,1.1-1.9,0.8c-0.8-0.3-1.1-1.1-0.8-1.9 C12.7,31.4,13.6,31.1,14.3,31.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M16.8,26.3c0.7,0.4,0.9,1.3,0.3,2c-0.4,0.7-1.3,0.9-2,0.3c-0.7-0.4-0.9-1.3-0.3-2 C15.1,26,16.1,25.9,16.8,26.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M20.2,21.7c0.6,0.6,0.6,1.6,0,2.1c-0.6,0.6-1.6,0.6-2.1,0c-0.6-0.6-0.6-1.6,0-2.1C18.8,21,19.7,21,20.2,21.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M24.1,18.2c0.4,0.7,0.2,1.6-0.4,2c-0.7,0.4-1.6,0.2-2-0.4c-0.4-0.7-0.2-1.6,0.4-2 C22.8,17.3,23.7,17.6,24.1,18.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M28.5,15.6c0.3,0.8,0,1.6-0.8,1.9s-1.6,0-1.9-0.8c-0.3-0.8,0-1.6,0.8-1.9C27.3,14.4,28.2,14.8,28.5,15.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M33.8,13.7c0.1,0.8-0.3,1.6-1.1,1.7c-0.8,0.1-1.6-0.3-1.7-1.1c-0.1-0.8,0.3-1.6,1.1-1.7 C32.8,12.3,33.5,12.9,33.8,13.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M35.7,8.6c0.1,0.8-0.3,1.4-1.1,1.7c-0.8,0.1-1.4-0.3-1.7-1.1c-0.1-0.8,0.3-1.4,1.1-1.7 C34.9,7.3,35.5,7.8,35.7,8.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M42.4,8.2c0,0.8-0.7,1.3-1.4,1.3s-1.3-0.7-1.3-1.4s0.7-1.3,1.4-1.3C41.8,6.8,42.4,7.4,42.4,8.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M50,9.4c-0.2,0.8-0.9,1.2-1.7,1c-0.8-0.2-1.2-0.9-1-1.7s0.9-1.2,1.7-1C49.7,8,50.1,8.7,50,9.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M55.1,11.4c-0.3,0.7-1.1,1-1.8,0.7c-0.7-0.3-1-1.1-0.7-1.8c0.3-0.7,1.1-1,1.8-0.7 C55.1,9.9,55.4,10.8,55.1,11.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M51.9,71.6c-0.3-0.7,0.1-1.6,0.8-1.8c0.7-0.3,1.6,0.1,1.8,0.8c0.3,0.7-0.1,1.6-0.8,1.8 C53,72.8,52.2,72.4,51.9,71.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M45.9,73.2c-0.1-0.8,0.3-1.4,1.1-1.7c0.8-0.1,1.4,0.3,1.7,1.1c0.1,0.8-0.3,1.4-1.1,1.7 C46.8,74.4,46.1,74,45.9,73.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M39,73.5c0-0.8,0.7-1.3,1.4-1.3s1.3,0.7,1.3,1.4c0,0.8-0.7,1.3-1.4,1.3C39.5,74.9,39,74.3,39,73.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M32.7,72.5c0.1-0.8,0.9-1.2,1.7-1.1c0.8,0.1,1.2,0.9,1.1,1.7s-0.9,1.2-1.7,1.1C33,74,32.5,73.3,32.7,72.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M26.5,70.3c0.3-0.7,1.1-1,1.8-0.7c0.7,0.3,1,1.1,0.7,1.8c-0.3,0.7-1.1,1-1.8,0.7C26.5,71.8,26.2,71,26.5,70.3 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M20.3,66.3c0.4-0.7,1.3-0.8,1.9-0.3c0.7,0.4,0.8,1.3,0.2,1.9c-0.4,0.7-1.3,0.8-1.9,0.3 C20,67.8,19.9,66.9,20.3,66.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M16.6,62.8c0.6-0.6,1.4-0.6,2,0c0.6,0.6,0.6,1.4,0,2c-0.6,0.6-1.4,0.6-2,0C16,64.1,16,63.3,16.6,62.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M12.9,57.8c0.7-0.4,1.6-0.2,1.9,0.4c0.4,0.7,0.2,1.4-0.4,1.9c-0.7,0.4-1.4,0.2-1.9-0.4 C12,59,12.2,58.1,12.9,57.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M10.4,52.9c0.7-0.3,1.6,0,1.8,0.7c0.3,0.7,0,1.6-0.7,1.8c-0.7,0.3-1.6,0-1.8-0.7C9.4,54,9.8,53.2,10.4,52.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M8.7,46.7c0.8-0.1,1.4,0.3,1.7,1.1c0.1,0.8-0.3,1.4-1.1,1.7c-0.8,0.1-1.4-0.3-1.7-1.1 C7.4,47.5,8,46.8,8.7,46.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M8.2,39.9c0.8,0,1.4,0.6,1.4,1.3s-0.6,1.4-1.3,1.4s-1.4-0.6-1.4-1.3C6.9,40.4,7.4,39.9,8.2,39.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M9.1,33.2c0.8,0.1,1.2,0.9,1.1,1.7c-0.1,0.8-0.9,1.2-1.7,1.1c-0.8-0.1-1.2-0.9-1.1-1.7 C7.7,33.5,8.3,33.1,9.1,33.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M11.1,27.2c0.7,0.3,1,1.1,0.8,1.8c-0.3,0.7-1.1,1-1.8,0.8c-0.7-0.3-1-1.1-0.8-1.8C9.7,27.3,10.4,27,11.1,27.2 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M14.3,21.8c0.7,0.4,0.8,1.3,0.4,1.9c-0.4,0.7-1.3,0.8-1.9,0.3c-0.7-0.4-0.8-1.3-0.3-1.9 C12.9,21.5,13.8,21.3,14.3,21.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M19.2,16.3c0.6,0.6,0.6,1.4,0,2c-0.6,0.6-1.4,0.6-2,0c-0.6-0.6-0.6-1.4,0-2C17.8,15.8,18.7,15.8,19.2,16.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M23.9,12.9c0.4,0.7,0.2,1.4-0.3,1.9c-0.7,0.4-1.6,0.2-1.9-0.4c-0.4-0.7-0.2-1.4,0.4-1.9 C22.7,12.1,23.4,12.3,23.9,12.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M29.5,10.2c0.3,0.7,0,1.6-0.8,1.8c-0.7,0.3-1.6,0-1.8-0.8c-0.3-0.7,0-1.6,0.8-1.8 C28.4,9.1,29.2,9.4,29.5,10.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M38.1,4.6c0,0.4-0.4,0.9-0.9,0.9c-0.4,0-0.9-0.4-0.9-0.9c0-0.4,0.4-0.9,0.9-0.9C37.8,3.7,38.1,4.1,38.1,4.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M41.4,0.7c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7c0-0.4,0.3-0.7,0.7-0.7C41.2,0,41.4,0.3,41.4,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M51,2c-0.1,0.3-0.4,0.7-0.9,0.6c-0.3-0.1-0.7-0.4-0.6-0.9C49.7,1.3,50,1,50.4,1.1C50.9,1.2,51.1,1.6,51,2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M58.3,4.7C58.2,5,57.8,5.2,57.4,5c-0.3-0.1-0.6-0.6-0.3-0.9c0.1-0.3,0.6-0.6,0.9-0.3 C58.3,3.9,58.4,4.2,58.3,4.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M55,78.5c-0.1-0.3,0-0.8,0.4-0.9c0.3-0.1,0.8,0,0.9,0.4c0.1,0.3,0,0.8-0.4,0.9C55.5,79.1,55.1,78.9,55,78.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M47.7,80.5c-0.1-0.3,0.2-0.8,0.6-0.8c0.3-0.1,0.8,0.2,0.8,0.6c0.1,0.3-0.2,0.8-0.6,0.8 C48.1,81.2,47.7,80.9,47.7,80.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M39.3,81.1c0-0.4,0.3-0.7,0.8-0.7c0.4,0,0.7,0.3,0.7,0.8c0,0.4-0.3,0.7-0.8,0.7 C39.5,81.8,39.2,81.4,39.3,81.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M30.9,79.8c0.1-0.3,0.4-0.7,0.9-0.6c0.3,0.1,0.7,0.4,0.6,0.9c-0.1,0.3-0.4,0.7-0.9,0.6 C31,80.5,30.8,80.2,30.9,79.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M23.4,77.1c0.1-0.3,0.6-0.6,0.9-0.3c0.3,0.1,0.6,0.6,0.3,0.9c-0.1,0.3-0.6,0.6-0.9,0.3 C23.4,77.9,23.3,77.4,23.4,77.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M16.3,72.6c0.2-0.3,0.7-0.3,1-0.1c0.3,0.2,0.3,0.7,0.1,1c-0.2,0.3-0.7,0.3-1,0.1C16.1,73.4,16,73,16.3,72.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M11.1,67.8c0.3-0.2,0.8-0.2,1,0c0.2,0.3,0.2,0.8,0,1c-0.3,0.2-0.8,0.2-1,0C10.8,68.5,10.8,68.1,11.1,67.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M6.9,62.2c0.3-0.2,0.8-0.1,1,0.2c0.2,0.3,0.1,0.8-0.2,1c-0.3,0.2-0.8,0.1-1-0.2C6.4,62.9,6.6,62.4,6.9,62.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M4,56.8c0.3-0.1,0.8,0,0.9,0.3c0.1,0.3,0,0.8-0.3,0.9c-0.3,0.1-0.8,0-0.9-0.3C3.4,57.3,3.6,56.9,4,56.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1.7,49.5c0.3-0.1,0.8,0.1,0.9,0.6C2.7,50.4,2.4,50.9,2,51c-0.3,0.1-0.8-0.1-0.9-0.6S1.2,49.7,1.7,49.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0.7,40.7c0.4,0,0.7,0.3,0.7,0.7C1.3,41.8,1,42,0.7,42C0.2,42,0,41.7,0,41.3C0,41,0.3,40.7,0.7,40.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1.4,33.2C1.8,33.3,2.1,33.7,2,34c-0.1,0.3-0.4,0.7-0.8,0.6c-0.4-0.1-0.7-0.4-0.6-0.8 C0.7,33.4,1.1,33.1,1.4,33.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M3.9,25.2c0.3,0.1,0.6,0.6,0.4,0.9c-0.1,0.3-0.6,0.6-0.9,0.3c-0.3-0.1-0.6-0.6-0.4-0.9 C3.1,25.2,3.6,25,3.9,25.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M7.9,18c0.3,0.2,0.4,0.7,0.2,1c-0.2,0.3-0.7,0.4-1,0.2c-0.3-0.2-0.4-0.7-0.2-1C7.1,17.8,7.6,17.8,7.9,18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M13.2,11.7c0.2,0.3,0.2,0.8,0,1c-0.3,0.2-0.8,0.2-1,0c-0.2-0.3-0.2-0.8,0-1C12.6,11.3,13,11.4,13.2,11.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M19.4,6.9c0.2,0.3,0.1,0.8-0.2,1c-0.3,0.2-0.8,0.1-1-0.2c-0.2-0.3-0.1-0.8,0.2-1C18.8,6.4,19.2,6.6,19.4,6.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M26.8,3.2c0.1,0.3,0,0.8-0.4,0.9c-0.3,0.1-0.8,0-0.9-0.4c-0.1-0.3,0-0.8,0.4-0.9C26.2,2.7,26.7,2.9,26.8,3.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M33.4,1.3c0.1,0.3-0.2,0.8-0.6,0.9C32.5,2.3,32.1,2,32,1.7s0.2-0.8,0.6-0.9C33,0.8,33.4,1,33.4,1.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M46.3,4.9c-0.1,0.4-0.6,0.8-1.1,0.7c-0.4-0.1-0.8-0.6-0.7-1.1c0.1-0.4,0.6-0.8,1.1-0.7 C46.1,4,46.4,4.4,46.3,4.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M53.7,6.8c-0.2,0.4-0.8,0.7-1.2,0.4C52,7,51.8,6.4,52,6c0.2-0.4,0.8-0.7,1.2-0.4C53.7,5.8,53.8,6.3,53.7,6.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M59.3,9.4C59,9.9,58.5,10,58.1,9.7c-0.4-0.3-0.6-0.8-0.2-1.2c0.3-0.4,0.9-0.6,1.2-0.2 C59.4,8.6,59.5,9.1,59.3,9.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M57.2,73.3c-0.2-0.4,0-1,0.4-1.1c0.4-0.2,1,0,1.1,0.4c0.2,0.4,0,1-0.4,1.1C58,74,57.4,73.8,57.2,73.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M50.7,75.9c-0.1-0.4,0.2-1,0.7-1c0.4-0.1,1,0.2,1,0.7c0.1,0.4-0.2,1-0.7,1C51.2,76.6,50.8,76.4,50.7,75.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M43.1,77.2c0-0.4,0.4-0.9,0.9-0.9c0.4,0,0.9,0.4,0.9,0.9s-0.4,0.9-0.9,0.9C43.5,78.1,43.1,77.6,43.1,77.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M35.2,76.8c0.1-0.4,0.6-0.8,1.1-0.7c0.4,0.1,0.8,0.6,0.7,1.1c-0.1,0.4-0.6,0.8-1.1,0.7 C35.4,77.8,35.1,77.3,35.2,76.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M28.9,75.2c0.2-0.4,0.8-0.7,1.2-0.4c0.4,0.2,0.7,0.8,0.4,1.2c-0.2,0.4-0.7,0.7-1.2,0.4 C28.9,76.2,28.7,75.6,28.9,75.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M21.7,71.8c0.3-0.4,0.9-0.4,1.2-0.2c0.4,0.3,0.4,0.9,0.2,1.2c-0.3,0.4-0.9,0.4-1.2,0.2 C21.4,72.6,21.3,72.1,21.7,71.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M16.1,67.5c0.3-0.3,0.9-0.3,1.2,0c0.3,0.3,0.3,0.9,0,1.2c-0.3,0.3-0.9,0.3-1.2,0 C15.8,68.4,15.8,67.9,16.1,67.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M11.9,62.9c0.4-0.2,1-0.1,1.2,0.2c0.2,0.4,0.1,1-0.2,1.2c-0.4,0.2-1,0.1-1.2-0.2 C11.3,63.7,11.4,63.1,11.9,62.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M8.7,57.7c0.4-0.2,1,0,1.1,0.4c0.2,0.4,0,1-0.4,1.1c-0.4,0.2-1,0-1.1-0.4C8,58.3,8.2,57.9,8.7,57.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M6.1,51.4c0.4-0.1,1,0.2,1.1,0.7s-0.2,1-0.7,1.1c-0.4,0.1-1-0.2-1.1-0.7C5.3,52.1,5.7,51.5,6.1,51.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M4.7,43.7c0.4,0,0.9,0.4,0.9,0.9c0,0.4-0.4,0.9-0.9,0.9c-0.4,0-0.9-0.4-0.9-0.9C3.8,44.1,4.1,43.7,4.7,43.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M4.8,36.8c0.4,0.1,0.8,0.6,0.7,1c-0.1,0.4-0.6,0.8-1,0.7c-0.4-0.1-0.8-0.6-0.7-1C3.8,37,4.3,36.7,4.8,36.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M6.3,29.7c0.4,0.2,0.7,0.7,0.4,1.1c-0.2,0.4-0.7,0.7-1.1,0.4C5.2,31,5,30.5,5.2,30.1 C5.3,29.7,5.9,29.5,6.3,29.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M9.2,23c0.4,0.2,0.6,0.8,0.2,1.2c-0.2,0.4-0.8,0.6-1.2,0.2c-0.4-0.2-0.6-0.8-0.2-1.2 C8.2,22.9,8.8,22.8,9.2,23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M13.8,16.7c0.3,0.3,0.3,0.9,0,1.2c-0.3,0.3-0.9,0.3-1.2,0c-0.3-0.3-0.3-0.9,0-1.2 C12.9,16.3,13.4,16.3,13.8,16.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M19,11.8c0.2,0.4,0.1,1-0.2,1.2c-0.4,0.2-1,0.1-1.2-0.2c-0.2-0.4-0.1-1,0.2-1.2C18.2,11.3,18.8,11.4,19,11.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M24.8,8.2c0.2,0.4,0,1-0.4,1.1c-0.4,0.2-1,0-1.1-0.4c-0.2-0.4,0-1,0.4-1.1C24.1,7.6,24.7,7.8,24.8,8.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M31.5,5.8c0.1,0.4-0.2,1-0.7,1c-0.4,0.1-1-0.2-1-0.7c-0.1-0.4,0.2-1,0.7-1C31,4.9,31.4,5.2,31.5,5.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M45.2,38.3c-0.4-2.8-2.1-3.8-4-3.8c-2.3,0-3.9,1.3-4.4,3.8H45.2z M50.1,45.7c-2.2,3-5.1,4.6-8.8,4.6 c-4.8,0-9.3-3-9.3-9.7c0-6.1,3.9-9.6,9-9.6c4.8,0,6.8,2.9,7.1,3.4c1.4,2.1,1.8,5.2,1.9,7H36.7c0.6,2.9,2.3,4.4,5.1,4.4 c3,0,4.1-1.8,4.7-2.4L50.1,45.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M57.7,31.5v2.6c0.6-0.9,1.8-3.1,5.8-3v4.4c-0.9,0-2.6,0.1-3.9,1.1c-1.9,1.4-1.9,3.2-1.9,6.2v6.7h-4.2V31.4 h4.2V31.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M77.1,38c-0.3-1.2-1.6-3.1-4.1-3.1c-2.4,0-4.4,2-4.4,5.6c0,3.2,1.7,5.7,4.6,5.7c2.8,0,3.8-2.1,4.3-3.6l3.8,2 c-1.4,3.9-5,5.7-8.1,5.7c-5,0-9-3.9-9-9.6c0-5.6,4-9.6,9.1-9.6c4.6,0,6.9,3,7.8,5.1L77.1,38z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErcLogo);
export default __webpack_public_path__ + "static/media/erc_logo.9bf7daed09d8fa13e9786366184e8990.svg";
export { ForwardRef as ReactComponent };